import React from 'react';

import withStyles from '@mui/styles/withStyles';
import Grid from '@mui/material/Grid';

// @mui/icons-material
import Timeline from '@mui/icons-material/Timeline';

// core components
import Card from '../md/components/Card/Card.jsx';
import CardHeader from '../md/components/Card/CardHeader.jsx';
import CardIcon from '../md/components/Card/CardIcon.jsx';
import CardBody from '../md/components/Card/CardBody.jsx';

import chartsStyle from '../assets/jss/crm/components/crmChartsStyle.jsx';

import TaskCompletionChart from './TaskCompletionChart';
import TopReferralFirmsChart from './TopReferralFirmsChart.jsx';

const localStyles = (theme) => ({
  ...chartsStyle(theme),
  card: {
    backgroundColor: '#e7e7e7',
    width: 'auto',
    padding: '0 10px',
    margin: '10px 10px',
  },
});

class Charts extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12} lg={6}>
            <Card className={classes.card}>
              <CardHeader icon>
                <CardIcon color="allevaOrange">
                  <Timeline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Activities Logged</h4>
              </CardHeader>
              <CardBody>
                <TaskCompletionChart />
              </CardBody>
            </Card>
          </Grid>
          <Grid item xs={12} lg={6}>
            <Card className={classes.card}>
              <CardHeader icon>
                <CardIcon color="allevaOrange">
                  <Timeline />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Top Referral Sources</h4>
              </CardHeader>
              <CardBody>
                <TopReferralFirmsChart />
              </CardBody>
            </Card>
          </Grid>
        </Grid>
      </div>
    );
  }
}

export default withStyles(localStyles)(Charts);
